export default __webpack_public_path__ + "static/media/deliland-gcoil-icon.76ea2668.png";